<mat-card>
  <mat-card-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
    Importar GeoJSON
  </mat-card-title>

  <div class="row justify-end align-center gap-15px">
    <input
      #input
      style="position: fixed; top: -20000px"
      type="file"
      accept=".txt,.json,.geojson"
      (change)="cargarInput($event)"
      class="input"
    />
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="input.click()"
    >
      <span>Cargar GeoJSON</span>
      <mat-icon>upload_file</mat-icon>
    </button>
  </div>

  <!-- Form -->
  <mat-card-content style="margin: 2em 0">
    <form
      id="formImportar"
      [formGroup]="form!"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <!-- CSV -->
      <app-textarea #textarea [form]="form" [controlName]="'geojson'" />
    </form>
  </mat-card-content>

  <mat-divider inset />

  <!-- Botones -->
  <mat-card-actions class="gap-3">
    <button
      mat-raised-button
      type="submit"
      form="formImportar"
      color="accent"
      class="flex-1"
      [disabled]="!form?.valid || loading"
    >
      GUARDAR
    </button>
    <button mat-raised-button type="button" class="flex-1" (click)="close()">
      Volver
    </button>
  </mat-card-actions>

  <!-- Progress Bar  -->
  <mat-card-footer>
    <mat-progress-bar [mode]="loading ? 'indeterminate' : 'determinate'" />
  </mat-card-footer>
</mat-card>
